import { Box, Typography } from '@mui/material';
import classNames from 'classnames';

import { OrganizationUnit } from '~/data/orgunits/types';

import { useSxStyles } from './useStyles';

type PropsType = {
  orgUnit?: OrganizationUnit;
  name?: string;
  number?: string;
  variant?: 'default' | 'inline' | 'name';
};

export const OrgUnitLabel = (props: PropsType) => {
  const { orgUnit, name, number, variant } = props;

  const sxStyles = useSxStyles();

  const orgName = orgUnit?.fOrgUnitName || name;
  const orgNumber = orgUnit?.fOrgUnitNumber || number;
  const showNumber = !!orgNumber && variant !== 'name';

  return (
    <Box sx={sxStyles.root}>
      {orgName}{' '}
      {showNumber && (
        <Typography
          component={'span'}
          className={classNames('unit-number', variant || 'default')}
        >
          {orgNumber}
        </Typography>
      )}
    </Box>
  );
};
